var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingzoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24878 16.3251L3.24878 21.1597M14.2488 16.3251L19.2488 21.1597M11.2488 1.82153V3.75535M11.2488 21.1597V16.3251M4.44878 16.3251H18.0488C19.1689 16.3251 19.7289 16.3251 20.1568 16.1144C20.5331 15.929 20.839 15.6331 21.0308 15.2692C21.2488 14.8556 21.2488 14.3141 21.2488 13.231V6.84945C21.2488 5.76641 21.2488 5.22489 21.0308 4.81123C20.839 4.44736 20.5331 4.15152 20.1568 3.96612C19.7289 3.75535 19.1689 3.75535 18.0488 3.75535H4.44878C3.32867 3.75535 2.76862 3.75535 2.3408 3.96612C1.96447 4.15152 1.65851 4.44736 1.46677 4.81123C1.24878 5.22489 1.24878 5.76641 1.24878 6.84945V13.231C1.24878 14.3141 1.24878 14.8556 1.46677 15.2692C1.65851 15.6331 1.96447 15.929 2.3408 16.1144C2.76862 16.3251 3.32867 16.3251 4.44878 16.3251Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8538 8.05148H17.0572",
    stroke: "#BBBBBB",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1749 10.0109H17.0573",
    stroke: "#BBBBBB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4335 12.0046H17.0573",
    stroke: "#BBBBBB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25692 10.4685H6.21538C5.56498 10.4685 5.01754 10.9392 4.94154 11.5638L4.6946 13.5932M9.25692 10.4685C10.3055 10.2432 11.1324 9.46447 11.3929 8.45691L11.5381 7.89525M9.25692 10.4685V12.3066C9.25692 12.9998 9.25692 13.3463 9.03421 13.5617C8.8115 13.777 8.45304 13.777 7.73615 13.777C7.01926 13.777 6.66081 13.777 6.43809 13.5617C6.21538 13.3463 6.21538 12.9998 6.21538 12.3066V11.939",
    stroke: "#BBBBBB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73629 9.18268C7.00101 9.18268 6.40495 8.60635 6.40495 7.8954C6.40495 7.18446 7.00101 6.60812 7.73629 6.60812C8.47157 6.60812 9.06763 7.18446 9.06763 7.8954C9.06763 8.60635 8.47157 9.18268 7.73629 9.18268Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingzoneIcon);
export default __webpack_public_path__ + "static/media/trainingzone_icon.9f95281bf25110c1b450aba204bb691d.svg";
export { ForwardRef as ReactComponent };